import React from "react";

export const Card = ({ title, desc, children, testid, right }) => (
  <section className="rounded-3xl border border-slate-200 bg-white p-5 sm:p-6" data-testid={testid}>
    <div className="flex flex-wrap items-start justify-between gap-3 mb-5">
      <div>
        <h2 className="text-lg font-semibold text-slate-900">{title}</h2>
        {desc && <p className="mt-1 text-sm text-slate-500 max-w-2xl">{desc}</p>}
      </div>
      {right}
    </div>
    {children}
  </section>
);

export const NumField = ({ label, value, onChange, prefix, suffix, step = 1, min = 0, testid, hint }) => (
  <label className="block">
    <span className="text-xs font-medium text-slate-600">{label}</span>
    <div className="mt-1.5 flex items-center h-11 rounded-xl border border-slate-200 bg-slate-50 focus-within:border-sky-400 focus-within:bg-white transition-colors">
      {prefix && <span className="pl-3 text-sm text-slate-400">{prefix}</span>}
      <input type="number" inputMode="decimal" step={step} min={min} value={value} data-testid={testid}
        onChange={(e) => onChange(e.target.value === "" ? "" : Number(e.target.value))}
        className="flex-1 min-w-0 h-full bg-transparent px-3 text-sm font-mono text-slate-900 outline-none" />
      {suffix && <span className="pr-3 text-sm text-slate-400">{suffix}</span>}
    </div>
    {hint && <span className="mt-1 block text-[11px] text-slate-400">{hint}</span>}
  </label>
);

export const inr = (v, dp = 0) => `${Number(v) < 0 ? "-" : ""}₹${Math.abs(Number(v || 0)).toLocaleString("en-IN", { minimumFractionDigits: dp, maximumFractionDigits: 2 })}`;
export const unitPrice = (base, markup) => Math.round(Number(base || 0) * (1 + Number(markup || 0) / 100) * 100) / 100;
export const packPrice = (credits, unit) => Math.max(1, Math.ceil(Number(credits || 0) * unit));
